import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import { concat } from 'lodash'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading module routes
 * -----------------------------------------------------------------------------------------------------------
 */
import homeRouter from '@/components/home/router'
import accountRouter from '@/components/account/router'
import categoryBlogRouter from '@/components/category-blogs/router'
import blogRouter from '@/components/blogs/router'
import pageRouter from '@/components/pages/router'
import contactRouter from '@/components/contacts/router'
import luckyWheelRouter from '@/components/luckywheels/router'
import settingRouter from '@/components/settings/router'
import userRouter from '@/components/users/router'
import userForEditorRouter from '@/components/users-for-editor/router'
import configmenuRouter from '@/components/configmenus/router'

import levelRouter from '@/components/levels/router'
import schoolRouter from '@/components/schools/router'
import facultRouter from '@/components/facults/router'
import specializedRouter from '@/components/specializeds/router'
import categoryCourseRouter from '@/components/category-courses/router'
import categoryTestRouter from '@/components/category-tests/router'
import categoryOnlineRouter from '@/components/category-online/router'
import courseRouter from '@/components/courses/router'
import chapterRouter from '@/components/chapters/router'
import lessonRouter from '@/components/lessons/router'
import questionRouter from '@/components/questions/router'
import questionOnlineRouter from '@/components/questions-online/router'
import testkitRouter from '@/components/test-kits/router'
import testkitOnlineRouter from '@/components/test-kits-online/router'
import configHomeRouter from '@/components/config-home/router'
import paymentRouter from '@/components/payments/router'
import bookingRouter from '@/components/bookings/router'
import commentRouter from '@/components/comments/router'
import testResultRouter from '@/components/test-results/router'
import keyRouter from '@/components/keys/router'
import classProRouter from '@/components/class-pros/router'
import classUserRouter from '@/components/class-users/router'
import classUserV2Router from '@/components/class-users-v2/router'
import userSchoolRouter from '@/components/user-schools/router'

import attributeKeyRouter from '@/components/attribute-keys/router'
import attributeValueRouter from '@/components/attribute-values/router'

import notificationRouter from '@/components/notifications/router'
import testResultV2Router from '@/components/test-results-v2/router'
import domainRouter from '@/components/domains/router'

import logRouter from '@/components/activity-logs/router'
import shortLinkRouter from '@/components/short-links/router'
import helpCareConfirmRouter from '@/components/help-care-confirms/router'
import helpCareRouter from '@/components/help-cares/router'

import classLiveRouter from '@/components/class-live/router'
import testRoomRouter from '@/components/test-rooms/router'
import notiFormRouter from '@/components/noti-form/router'

Vue.use(Router)

Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: concat(
    homeRouter,
    accountRouter,
    categoryBlogRouter,
    blogRouter,
    pageRouter,
    contactRouter,
    luckyWheelRouter,
    settingRouter,
    userRouter,

    configmenuRouter,

    levelRouter,
    schoolRouter,
    facultRouter,
    specializedRouter,
    categoryCourseRouter,
    courseRouter,
    chapterRouter,
    lessonRouter,
    questionRouter,
    testkitRouter,
    configHomeRouter,
    paymentRouter,
    bookingRouter,
    commentRouter,
    testResultRouter,
    keyRouter,
    classProRouter,
    classUserRouter,
    classUserV2Router,
    userSchoolRouter,
    categoryTestRouter,
    testkitOnlineRouter,
    questionOnlineRouter,

    attributeKeyRouter,
    attributeValueRouter,
    categoryOnlineRouter,

    notificationRouter,
    testResultV2Router,
    userForEditorRouter,
    domainRouter,

    logRouter,
    shortLinkRouter,
    helpCareConfirmRouter,
    helpCareRouter,

    classLiveRouter,
    testRoomRouter,
    notiFormRouter
  )
})



// WEBPACK FOOTER //
// ./src/router/index.js